import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { List, WingBlank } from 'antd-mobile'
import CardLayout from '../../components/common/CardLayout'
import { FormattedMessage, useIntl } from 'react-intl'
import UploadOssFile from '../../components/common/UploadOssFile'
import UploadFileWrapper from '../../components/common/UploadFileWrapper'
import TrainingInfo from './TrainingInfo'
import { removeAFDIFile, uploadAFDIOssFile } from '../../reducers/afdi'

const Item = List.Item

/**
 * CHNA-2766：AFDI 选项 2 的「候选人认证信息和签证要求」。
 * 方法 1：PADI 自由潜水员教练 + ≥25 张 PADI 签证（系统自动识别，可上传兜底）；
 * 方法 2：非 PADI 教练 + FDIT 交叉课程 + 25 张其他机构证书（证书与签证详情必传）。
 */
const CheckTeachingCerts = ({
  editable,
  candidateMethod,
  fdi,
  teachingCount,
  fdiFiles,
  teachingCountFiles,
  updateFormData,
  cdinstructorNumber,
  storeNumber,
  finishDate,
  courseLocation,
}) => {
  const { ossSignature } = useSelector((state) => ({
    ossSignature: state.oss.ossSignature,
  }))
  const dispatch = useDispatch()
  const { formatMessage } = useIntl()

  const filename = (type) => `${ossSignature.dir}${type}/${new Date().getTime()}`
  const fdiFileList = fdiFiles || []
  const teachingFileList = teachingCountFiles || []

  const method1Complete = (fdi || fdiFileList.length > 0)
    && (teachingCount || teachingFileList.length > 0)
  const crossCourseComplete = Boolean(cdinstructorNumber && courseLocation && finishDate)
  const method2Complete = !fdi
    && fdiFileList.length > 0
    && teachingFileList.length > 0
    && crossCourseComplete
  const complete = candidateMethod === 'method2' ? method2Complete : method1Complete

  const selectMethod = (method) => {
    if (!editable) return
    updateFormData({ candidateMethod: method })
  }

  return (
    <CardLayout title={<FormattedMessage id="afdi-candidate-title" />} status={complete}>
      {/* 方法 1 */}
      <Item
        multipleLine
        wrap
        extra={candidateMethod === 'method1' ? '◉' : '○'}
        onClick={() => selectMethod('method1')}
      >
        <FormattedMessage id="afdi-candidate-method1" />
      </Item>

      {candidateMethod === 'method1' && (
        <>
          {fdi ? (
            <Item>
              <FormattedMessage id="afdi-padi-fdi" /> <FormattedMessage id="afdi-satisfy" />
            </Item>
          ) : (
            <UploadFileWrapper labelName={formatMessage({ id: 'afdi-candidate-method1-fdi' })} editable={editable}>
              <UploadOssFile
                fileList={fdiFileList}
                fileName={filename('fdi')}
                onChange={(formData) => dispatch(uploadAFDIOssFile({ formData }))}
                onDelete={(index) => dispatch(removeAFDIFile(fdiFileList[index]))}
                editable={editable}
              />
              {editable && (
                <WingBlank>
                  <div className="small-font gray">
                    <FormattedMessage id="common-upload-file-reminder" />
                  </div>
                </WingBlank>
              )}
            </UploadFileWrapper>
          )}
          {teachingCount ? (
            <Item>
              <FormattedMessage id="afdi-satisfy-certs" />
            </Item>
          ) : (
            <UploadFileWrapper labelName={formatMessage({ id: 'afdi-candidate-method1-teaching' })} editable={editable}>
              <UploadOssFile
                fileList={teachingFileList}
                fileName={filename('teachingCerts')}
                onChange={(formData) => dispatch(uploadAFDIOssFile({ formData }))}
                onDelete={(index) => dispatch(removeAFDIFile(teachingFileList[index]))}
                editable={editable}
              />
              {editable && (
                <WingBlank>
                  <div className="small-font gray">
                    <FormattedMessage id="afdi-upload-cert-requirement" />
                  </div>
                </WingBlank>
              )}
            </UploadFileWrapper>
          )}
        </>
      )}

      {/* 方法 2 */}
      <Item
        multipleLine
        wrap
        extra={candidateMethod === 'method2' ? '◉' : '○'}
        onClick={() => selectMethod('method2')}
      >
        <FormattedMessage id="afdi-candidate-method2" />
      </Item>

      {candidateMethod === 'method2' && (
        <>
          <UploadFileWrapper labelName={formatMessage({ id: 'afdi-candidate-method2-cert' })} editable={editable}>
            <UploadOssFile
              fileList={fdiFileList}
              fileName={filename('fdi')}
              onChange={(formData) => dispatch(uploadAFDIOssFile({ formData }))}
              onDelete={(index) => dispatch(removeAFDIFile(fdiFileList[index]))}
              editable={editable}
            />
            {editable && (
              <WingBlank>
                <div className="small-font gray">
                  <FormattedMessage id="common-upload-file-reminder" />
                </div>
              </WingBlank>
            )}
          </UploadFileWrapper>
          <UploadFileWrapper labelName={formatMessage({ id: 'afdi-candidate-method2-teaching' })} editable={editable}>
            <UploadOssFile
              fileList={teachingFileList}
              fileName={filename('teachingCerts')}
              onChange={(formData) => dispatch(uploadAFDIOssFile({ formData }))}
              onDelete={(index) => dispatch(removeAFDIFile(teachingFileList[index]))}
              editable={editable}
            />
            {editable && (
              <WingBlank>
                <div className="small-font gray">
                  <FormattedMessage id="afdi-upload-cert-requirement" />
                </div>
              </WingBlank>
            )}
          </UploadFileWrapper>
          <TrainingInfo
            editable={editable}
            updateFormData={updateFormData}
            cdinstructorNumber={cdinstructorNumber}
            storeNumber={storeNumber}
            finishDate={finishDate}
            courseLocation={courseLocation}
            titleId="afdi-cross-course-title"
          />
        </>
      )}
    </CardLayout>
  )
}

export default CheckTeachingCerts
